import * as React from "react";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";

import { AppCardButton } from "./AppCardButton";
import { School, LocalPharmacy } from "@material-ui/icons";
import { usersAdminStore } from '../admin/modules/UsersAdmin';
import { toJS } from 'mobx';
import { Loading } from 'src/components/loading';
import { observer } from 'mobx-react';
import { authStore } from '../auth';

const styles = createStyles({
  root: {
    padding: "2rem"
  },
  appNavigationContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "1rem"
  },
  pharmacyCard: {
    background: "#192e5b"
  },
  universityCard: {
    background: "#3333bb"
  },
  disabledCard: {
    background: "#737373",
    cursor: "not-allowed"
  }
});

interface IPharmacyRole {
  pharmacy_role_id: number;
  PharmacyRoleName: string;
  PharmacyQualified: number;
}

interface IUniversityRole {
  auth_id: number;
  role_id: number;
  link_id: number;
  company_id: number;
  Active: number;
  IsNewUser: number;
  LastLogin: string;
  university_role_id: number;
  UniversityRoleName: string;
  from_db: number;
}

interface IChatRole {
  role: string;
}

interface IRole
  extends Partial<IPharmacyRole>,
    Partial<IUniversityRole>,
    Partial<IChatRole> {}

interface IAppMeta {
  app_id: number;
  App: string;
  Active: boolean;
  roles: IRole[];
  deletedRoles: IRole[];
  relationExists: boolean;
}

interface IProps extends WithStyles<typeof styles> {
  apps: IAppMeta[];
  handleClick(appType: string): () => void;
}

enum AppType {
  Pharmacy = 1,
  University = 2,
  Chat = 3
}

@observer
class AppNavigationUnstyled extends React.Component<IProps> {
  public renderNavigationButtons = () => {
    const { apps } = this.props;

    return apps
      .filter(
        app =>
          app && (app.app_id === AppType.Pharmacy || app.app_id === AppType.University)
      )
      .map(app => {
        if (!app.Active) {
          return null;
        }

        switch (app.app_id) {
          case AppType.Pharmacy:
            const pharmacyQualified = app.roles[0].PharmacyQualified;

            const tooltip = !pharmacyQualified
              ? "Please complete Pharmacy intro courses on the University App"
              : "";

            return (
              <AppCardButton
                tooltip={tooltip}
                disable={!pharmacyQualified}
                label={app.App}
                bgColor={
                  !pharmacyQualified
                    ? this.props.classes.disabledCard
                    : this.props.classes.pharmacyCard
                }
                icon={<LocalPharmacy />}
                onClick={this.props.handleClick(String(app.App).toLowerCase())}
              />
            );
          case AppType.University:
            // disable if they dont have any company rels
            if (authStore.currentUser.Companies.length === 0) {
              return (null)
            }
            return (
              <AppCardButton
                
                label={app.App}
                bgColor={this.props.classes.universityCard}
                icon={<School />}
                onClick={this.props.handleClick(String(app.App).toLowerCase())}
              />
            );
          default:
            return null;
        }
      });
  };

  public render() {
    
    return (
      <div className={this.props.classes.appNavigationContainer}>
        {this.renderNavigationButtons()}
      </div>
    );
  }
}

export const AppNavigation = withStyles(styles, { withTheme: true })(
  AppNavigationUnstyled
);



// WEBPACK FOOTER //
// ./src/modules/apps/AppNavigation.tsx